<template>
  <svg
    id="Renewables"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    style="enable-background: new 0 0 60 60"
    xml:space="preserve"
  >
    <title>measureIcon-renewables</title>
    <path
      class="st0"
      d="M26,3L26,3c0,0.3,0.3,0.6,0.7,0.5c0.2,0,0.4-0.1,0.5-0.3l0,0c0.6-1.3,2.1-1.8,3.4-1.2c1.1,0.5,1.7,1.7,1.4,2.8
	l0,0c-0.1,0.3,0.1,0.6,0.5,0.7c0.2,0,0.4,0,0.6-0.2l0,0c1-1,2.6-1.1,3.6-0.1c0.8,0.8,1,2,0.5,3.1l0,0c-0.2,0.3-0.1,0.6,0.2,0.8
	c0.2,0.1,0.4,0.1,0.6,0l0,0c1.3-0.6,2.8-0.2,3.5,1.1c0.5,1,0.3,2.2-0.5,3l0,0c-0.2,0.2-0.3,0.6,0,0.8c0.1,0.2,0.4,0.2,0.6,0.2l0,0
	c1.4-0.3,2.7,0.6,3,2c0.2,1.2-0.4,2.3-1.4,2.8l0,0c-0.3,0.1-0.4,0.5-0.3,0.8c0.1,0.2,0.3,0.3,0.5,0.3l0,0c1.4,0.2,2.4,1.4,2.2,2.8
	c-0.1,1.2-1.1,2.1-2.2,2.2l0,0c-0.3,0-0.6,0.3-0.5,0.7c0,0.2,0.1,0.4,0.3,0.5l0,0c1.3,0.6,1.8,2.1,1.2,3.4c-0.5,1.1-1.7,1.7-2.8,1.4
	l0,0c-0.3-0.1-0.6,0.1-0.7,0.5c0,0.2,0,0.4,0.2,0.6l0,0c1,1,1.1,2.6,0.1,3.6c-0.8,0.8-2,1-3.1,0.5l0,0c-0.3-0.2-0.6-0.1-0.8,0.2
	c-0.1,0.2-0.1,0.4,0,0.6l0,0c0.7,1.2,0.2,2.8-1,3.5c-1,0.5-2.3,0.3-3.1-0.5l0,0c-0.2-0.2-0.6-0.3-0.8,0c-0.2,0.1-0.2,0.4-0.2,0.6
	l0,0c0.3,1.4-0.6,2.7-2,3c-1.2,0.2-2.3-0.4-2.8-1.4l0,0c-0.1-0.3-0.5-0.4-0.8-0.3C26.1,42,26,42.2,26,42.4l0,0
	c-0.2,1.4-1.4,2.4-2.8,2.2c-1.2-0.1-2.1-1.1-2.2-2.2l0,0c0-0.3-0.3-0.6-0.7-0.5c-0.2,0-0.4,0.1-0.5,0.3l0,0
	c-0.6,1.3-2.1,1.8-3.4,1.2c-1.1-0.5-1.7-1.7-1.4-2.8l0,0c0.1-0.3-0.1-0.6-0.5-0.7c-0.2,0-0.4,0-0.6,0.2l0,0c-1,1-2.6,1.1-3.6,0.1
	c-0.8-0.8-1-2-0.5-3.1l0,0c0.2-0.3,0.1-0.6-0.2-0.8c-0.2-0.1-0.4-0.1-0.6,0l0,0c-1.2,0.7-2.8,0.2-3.5-1C5,34.3,5.2,33,6,32.2l0,0
	c0.2-0.2,0.3-0.6,0-0.8c-0.1-0.2-0.4-0.2-0.6-0.2l0,0c-1.4,0.3-2.7-0.6-3-2c-0.2-1.2,0.4-2.3,1.4-2.8l0,0c0.3-0.1,0.4-0.5,0.3-0.8
	c-0.1-0.2-0.3-0.3-0.5-0.3l0,0c-1.4-0.2-2.4-1.4-2.2-2.8c0.1-1.2,1.1-2.1,2.2-2.2l0,0c0.3,0,0.6-0.3,0.5-0.7c0-0.2-0.1-0.4-0.3-0.5
	l0,0c-1.3-0.6-1.8-2.1-1.2-3.4c0.5-1.1,1.7-1.7,2.8-1.4l0,0c0.3,0.1,0.6-0.1,0.7-0.5c0-0.2,0-0.4-0.2-0.6l0,0C5,12.2,5,10.6,6,9.6
	c0.8-0.8,2-1,3.1-0.5l0,0c0.3,0.2,0.6,0.1,0.8-0.2c0.1-0.2,0.1-0.4,0-0.6l0,0c-0.7-1.2-0.2-2.8,1-3.5c1-0.5,2.3-0.3,3.1,0.5l0,0
	c0.2,0.2,0.6,0.3,0.8,0C14.9,5.2,15,5,15,4.7l0,0c-0.3-1.4,0.5-2.8,1.9-3.1c1.2-0.3,2.5,0.4,3,1.5l0,0c0.1,0.3,0.5,0.4,0.8,0.3
	c0.2-0.1,0.3-0.3,0.3-0.5l0,0c0.2-1.4,1.5-2.3,2.9-2.1C25,1.1,25.8,1.9,26,3z"
    />
    <path
      class="st1"
      d="M26,42.4c-0.2,1.4-1.4,2.4-2.8,2.2c-1.2-0.1-2.1-1.1-2.2-2.2c0-0.4-0.7-0.6-0.7-0.5v17.3h6V42
	C26.2,41.9,26,42.2,26,42.4z"
    />
    <path
      class="st1"
      d="M26.2,34c0-4.4,3.6-8,8-8l0,0"
    />
    <path
      class="st1"
      d="M20.2,37c0-4.4-3.6-8-8-8"
    />
    <path
      class="st1"
      d="M22.2,26c0-4.4-3.6-8-8-8"
    />
    <path
      class="st1"
      d="M23.2,17.9c0-4.4,3.6-8,8-8"
    />
    <path
      class="st1"
      d="M35.3,14.9c0,1.7,1.4,3,3,3"
    />
    <path
      class="st1"
      d="M29.2,22c0-1.7,1.4-3,3-3h0"
    />
    <path
      class="st1"
      d="M17.2,7.9c0,1.7,1.4,3,3,3h0"
    />
    <path
      class="st1"
      d="M12.1,21c0,1.7-1.4,3-3,3h0"
    />
    <path
      class="st1"
      d="M33.3,34c0-1.7,1.4-3,3-3l0,0"
    />
    <line
      class="st1"
      x1="17.2"
      y1="58.1"
      x2="17.2"
      y2="59.2"
    />
    <line
      class="st1"
      x1="14.2"
      y1="58.1"
      x2="14.2"
      y2="59.2"
    />
    <line
      class="st1"
      x1="11.1"
      y1="58.1"
      x2="11.1"
      y2="59.2"
    />
    <line
      class="st1"
      x1="8.1"
      y1="58.1"
      x2="8.1"
      y2="59.2"
    />
    <line
      class="st1"
      x1="5.1"
      y1="58.1"
      x2="5.1"
      y2="59.2"
    />
    <line
      class="st1"
      x1="35.3"
      y1="58.1"
      x2="35.3"
      y2="59.2"
    />
    <line
      class="st1"
      x1="32.3"
      y1="58.1"
      x2="32.3"
      y2="59.2"
    />
    <line
      class="st1"
      x1="29.2"
      y1="58.1"
      x2="29.2"
      y2="59.2"
    />
    <line
      class="st1"
      x1="44.3"
      y1="58.1"
      x2="44.3"
      y2="59.2"
    />
    <line
      class="st1"
      x1="41.3"
      y1="58.1"
      x2="41.3"
      y2="59.2"
    />
    <line
      class="st1"
      x1="38.3"
      y1="58.1"
      x2="38.3"
      y2="59.2"
    />
    <line
      class="st1"
      x1="53.4"
      y1="58.1"
      x2="53.4"
      y2="59.2"
    />
    <line
      class="st1"
      x1="50.3"
      y1="58.1"
      x2="50.3"
      y2="59.2"
    />
    <line
      class="st1"
      x1="47.3"
      y1="58.1"
      x2="47.3"
      y2="59.2"
    />
    <path
      class="st2"
      d="M52.4,12.9c0-3.3,2.7-6,6-6c0,0,0,0,0,0"
    />
    <path
      class="st2"
      d="M52.4,12.9c0-2.8-2.3-5.1-5.1-5.1"
    />
    <circle
      class="st3"
      cx="13.1"
      cy="14.6"
      r="1.8"
    />
    <circle
      class="st3"
      cx="39.5"
      cy="23.5"
      r="1.8"
    />
    <circle
      class="st3"
      cx="17.1"
      cy="23.1"
      r="1.8"
    />
    <circle
      class="st3"
      cx="23.5"
      cy="7.2"
      r="1.8"
    />
    <ellipse
      transform="matrix(0.8866 -0.4626 0.4626 0.8866 -13.4541 18.4186)"
      class="st3"
      cx="30.8"
      cy="36.6"
      rx="1.8"
      ry="1.8"
    />
    <circle
      class="st3"
      cx="13.3"
      cy="34.1"
      r="1.8"
    />
    <circle
      class="st3"
      cx="8.5"
      cy="18.4"
      r="1.8"
    />
    <circle
      class="st3"
      cx="25.8"
      cy="22.6"
      r="1.8"
    />
    <circle
      class="st3"
      cx="22.3"
      cy="30.5"
      r="1.8"
    />
    <circle
      class="st3"
      cx="30.8"
      cy="14.3"
      r="1.8"
    />
    <ellipse
      transform="matrix(0.866 -0.5 0.5 0.866 -6.639 20.2228)"
      class="st3"
      cx="34.4"
      cy="22.5"
      rx="1.8"
      ry="1.8"
    />
    <circle
      class="st3"
      cx="25.3"
      cy="38.2"
      r="1.8"
    />
    <circle
      class="st3"
      cx="14"
      cy="10.1"
      r="1.8"
    />
    <circle
      class="st3"
      cx="20"
      cy="15.2"
      r="1.8"
    />
    <ellipse
      transform="matrix(0.866 -0.5 0.5 0.866 -13.0037 7.9278)"
      class="st3"
      cx="8.3"
      cy="28.2"
      rx="1.8"
      ry="1.8"
    />
    <circle
      class="st3"
      cx="31.7"
      cy="30"
      r="1.8"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    return {};
  },
});
</script>

<style scoped lang="scss">
.st0 {
  fill: none;
  stroke: #7dc142;
  stroke-width: 1.5;
  stroke-miterlimit: 10;
}
.st1 {
  fill: none;
  stroke: #7dc142;
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-miterlimit: 10;
}
.st2 {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-miterlimit: 10;
}
.st3 {
  fill: #7dc142;
}
</style>
